import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/deals/[id]/Page";

export const PATH = (id: number): string => `/deals/${id}`;

function DealsDetail() {
	return (
		<>
			<NskHead title="案件詳細" />
			<Component />
		</>
	);
}

export default DealsDetail;
